import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Check as CheckIcon, Close as CloseIcon } from "@material-ui/icons";
import { useQuery } from "@redux-requests/react";
import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { types } from "../ducks";
import { getMeeting } from "../ducks/actions";
import { dateTimeInterval } from "../ducks/utils";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(2),
    paddingBottom: 0
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  iconContainer: {
    backgroundColor: theme.palette.success.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1.5)
  }
}));

const MeetingConfirmDialog = ({ meetingId, onClose }) => {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMeeting({ id: meetingId }));
  }, [dispatch, meetingId]);

  const {
    data: { data: meeting }
  } = useQuery({ type: types.GET_MEETING, defaultData: { data: {} } });

  return (
    !isEmpty(meeting) && (
      <Dialog open maxWidth="xs" fullWidth onClose={onClose}>
        <div className={classes.title}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent className={classes.content}>
          <span className={classes.iconContainer}>
            <CheckIcon />
          </span>
          <Typography variant="h5" align="center">
            <strong>
              {intl.formatMessage({
                id: "Exhibitors.MeetingConfirmDialog.BookingConfirmed",
                defaultMessage: "Booking confirmed"
              })}
            </strong>
          </Typography>
          <Typography variant="body1" align="center" paragraph>
            {intl.formatMessage(
              {
                id: "Exhibitors.MeetingConfirmDialog.MeetingConfirmHelper",
                defaultMessage: "You are scheduled with {exhibitorProfileFullName}"
              },
              {
                exhibitorProfileFullName: `${meeting?.meetingSlot?.profile?.firstName} ${meeting?.meetingSlot?.profile?.lastName}`
              }
            )}
            <br />
            {dateTimeInterval(meeting?.meetingSlot?.startAt, meeting?.meetingSlot?.endAt)}
            <br />
          </Typography>
          <Typography variant="body1" align="center">
            <strong>
              {intl.formatMessage(
                {
                  id: "Exhibitors.MeetingConfirmDialog.CalendarInvitationHelper",
                  defaultMessage: "A calendar invitation has been sent to your email address."
                },
                {
                  exhibitorProfileFullName: `${meeting.meetingSlot.profile.firstName} ${meeting.meetingSlot.profile.lastName}`
                }
              )}
            </strong>
          </Typography>
        </DialogContent>
        <DialogActions />
      </Dialog>
    )
  );
};

export default MeetingConfirmDialog;
